import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActiveModalModuleComponent } from './active-modal-module.component';
import { ActiveModalModule } from './active-modal-module.types';

@Injectable({
  providedIn: 'root',
})
export class ActiveModalModuleService {
  private refreshListSource = new Subject<ActiveModalModule.Result>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(private dialog: MatDialog) {}
  open(config: MatDialogConfig = new MatDialogConfig()) {
    const dialogRef = this.dialog.open<
      ActiveModalModuleComponent,
      ActiveModalModule.Params,
      ActiveModalModule.Result
    >(ActiveModalModuleComponent, config);

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        this.refreshListSource.next(res);
      })
    );
  }
}
